import { Checkbox, IconButton, Tooltip, Typography } from "@material-ui/core";
import React from "react";
import UncheckedboxIcon from "../../icons/UncheckedboxIcon";
import CheckedboxIcon from "../../icons/CheckedboxIcon";
import RemoveRoundedIcon from "@material-ui/icons/RemoveRounded";
import MenuRoundedIcon from "@material-ui/icons/MenuRounded";

const FormColumn = ({
  columnName,
  isChecked = false,
  checkboxStyle,
  selectedIconStyle,
  isSelected = false,
  variableId,
  dragHandle = {},
  onColumnClick = () => {},
}) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
      data-testid="form-item"
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "3px",
        }}
      >
        {isSelected && (
          <Tooltip placement="bottom" title="Reorder column on data table">
            <IconButton
              {...dragHandle}
              edge="start"
              color="inherit"
              aria-label="drag-and-drop"
              size="small"
            >
              <MenuRoundedIcon fontSize="medium" />
            </IconButton>
          </Tooltip>
        )}

        <Typography
          style={{
            fontFamily: "Avenir",
            fontSize: "14px",
            fontWeight: 500,
            color: "#535353",
          }}
        >
          {columnName}
        </Typography>
      </div>

      {isSelected ? (
        <Tooltip placement="bottom" title="Remove column from data table">
          <IconButton
            edge="start"
            onClick={() => onColumnClick(variableId)}
            aria-label="remove-from-list"
            size="small"
          >
            <RemoveRoundedIcon
              fontSize="large"
              classes={{
                fontSizeLarge: selectedIconStyle,
              }}
            />
          </IconButton>
        </Tooltip>
      ) : (
        <Checkbox
          checked={isChecked}
          onChange={() => onColumnClick(variableId)}
          className={checkboxStyle}
          size="medium"
          icon={<UncheckedboxIcon />}
          checkedIcon={<CheckedboxIcon />}
          inputProps={{
            "aria-label": "create-data-table checkbox",
          }}
        />
      )}
    </div>
  );
};

export default FormColumn;
